export default [
  {
    path: '/document-constructor-pane',
    component: () => import('./views/constructor.vue'),
    meta: {
      layout: 'empty',
    },
  },
];
